module.exports = __webpack_public_path__ + "media/dogs/dog-in-cone-4fa7af69.svg";